import { render, staticRenderFns } from "./SlideConfirmation.vue?vue&type=template&id=67a98fac&scoped=true"
import script from "./SlideConfirmation.vue?vue&type=script&lang=ts"
export * from "./SlideConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./SlideConfirmation.vue?vue&type=style&index=0&id=67a98fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a98fac",
  null
  
)

export default component.exports